import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();

  // Mapear rotas para breadcrumbs
  const getBreadcrumbs = (pathname: string): BreadcrumbItem[] => {
    const segments = pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Dashboard', href: '/' }
    ];

    let currentPath = '';

    segments.forEach((segment, index) => {
      currentPath += `/${segment}`;

      // Mapear segmentos para labels legíveis
      const labelMap: Record<string, string> = {
        'alunos': 'Alunos',
        'empresas': 'Empresas',
        'cidades': 'Cidades',
        'cursos': 'Cursos',
        'estagios': 'Estágios',
        'instituicoes': 'Instituições',
        'seguradoras': 'Seguradoras',
        'horarios': 'Horários',
        'relatorios': 'Relatórios',
        'termo-contrato': 'Termo de Contrato',
        'termo-rescisao': 'Termo de Rescisão',
        'novo': 'Novo',
        'nova': 'Nova',
        'editar': 'Editar',
        'ver': 'Ver'
      };

      const label = labelMap[segment] || segment;

      // Último item não tem href (página atual)
      const isLast = index === segments.length - 1;

      breadcrumbs.push({
        label,
        href: isLast ? undefined : currentPath
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs(location.pathname);

  // Não mostrar breadcrumbs se estiver apenas no dashboard
  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-1 text-sm text-gray-500 mb-4" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronRightIcon className="h-4 w-4 text-gray-400 mx-1" />
              )}

              {index === 0 && (
                <HomeIcon className="h-4 w-4 text-gray-400 mr-1" />
              )}

              {isLast ? (
                <span className="text-gray-900 font-medium">
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href!}
                  className="text-gray-500 hover:text-gray-700 transition-colors"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};